module.exports = __webpack_public_path__ + "media/tile-1-heading-new.56c677be.png";